import { FC } from 'react';

import { Banner, Link, Text, VSpacing } from '@hh.ru/magritte-ui';

import { formatToReactComponent } from 'bloko/common/trl';

import useTrls from 'hooks/translation/useTrls';

import { SessionType } from 'store/models/user';
import { useSelector } from 'store/utils';

enum InformationTrlKey {
    UserWithoutAdvCampaigns = 'userWithoutAdvCampaigns',
    UserWithAdvCampaigns = 'userWithAdvCampaigns',
}

const TrlKeys = {
    description: 'RequisitesForm.description',
    descriptionLink: 'RequisitesForm.description.link',
    info: {
        sudoText: 'RequisitesForm.information.sudo.text',
        [InformationTrlKey.UserWithAdvCampaigns]: {
            part1: 'RequisitesForm.information.userWithAdvCampaigns.text.part1',
            part2: 'RequisitesForm.information.userWithAdvCampaigns.text.part2',
        },
        [InformationTrlKey.UserWithoutAdvCampaigns]: {
            part1: 'RequisitesForm.information.userWithoutAdvCampaigns.text.part1',
            part2: 'RequisitesForm.information.userWithoutAdvCampaigns.text.part2',
        },
    },
    requisitesHelp: 'RequisitesForm.information.help',
};

const ABOUT_ADS_LINK = 'https://hh.ru/article/about_ads';
const HOW_TO_FILL_REQUISITES_LINK = 'https://feedback.hh.ru/knowledge-base/article/00918';

export const RequisitesFormInfo: FC<{ isRequisitesEditable: boolean }> = ({ isRequisitesEditable }) => {
    const existAdvertisingCampaigns = useSelector((state) => state.existAdvertisingCampaigns);
    const isSudo = useSelector((state) => state.user.sessionType === SessionType.Sudo);

    const trl = useTrls();

    const informationTrlKey = existAdvertisingCampaigns
        ? InformationTrlKey.UserWithAdvCampaigns
        : InformationTrlKey.UserWithoutAdvCampaigns;

    return (
        <>
            {isRequisitesEditable && (
                <>
                    <Text typography="paragraph-2-regular" style="secondary">
                        {formatToReactComponent(trl(TrlKeys.description), {
                            '[0]': (
                                <Link inline target="_blank" href={ABOUT_ADS_LINK} enableVisited={false}>
                                    {trl(TrlKeys.descriptionLink)}
                                </Link>
                            ),
                            '[1]': (
                                <Link inline Element="a" target="_blank" href={HOW_TO_FILL_REQUISITES_LINK}>
                                    {trl(TrlKeys.requisitesHelp)}
                                </Link>
                            ),
                        })}
                    </Text>
                    <VSpacing default={24} />
                </>
            )}
            <Banner
                showClose={false}
                style="warning-secondary"
                stretched
                content={
                    isSudo ? (
                        <Text>{trl(TrlKeys.info.sudoText)}</Text>
                    ) : (
                        <>
                            <Text typography="paragraph-2-regular">{trl(TrlKeys.info[informationTrlKey].part1)}</Text>
                            <VSpacing default={10} />
                            <Text typography="paragraph-2-regular">{trl(TrlKeys.info[informationTrlKey].part2)}</Text>
                        </>
                    )
                }
            />
        </>
    );
};
